module.exports = __webpack_public_path__ + "img/IMG_1454_L_Black_MockedUp.a0793375.jpg";